import React from "react"
import { NavLink } from "react-router-dom"
import moment from "moment"

/**
 * UI components
 */
import Badge from "../ui/badge/badge"

/**
 * Presentational component to render a booking row
 * All data is passed in as props - no data fetching
 */
function Booking({ id, details, client, agent, returnDate, commissionData, show_email }) {
	/**
	 * Get the margin values from the sales margins
	 */
	const { agents_margin, customer_price, profit } = details?.margins || {}

	/**
	 * Generate a string to represent the check_in date from the timestamps
	 */
	const checkInDate = moment(details.check_in?.seconds, "X").format("MMM D[,] YYYY")
	const bookedDate = moment(details.booked?.seconds, "X").format("MMM D[,] YYYY")

	/**
	 * Work out a margin for the booking
	 */
	const bookingProfitPercent = profit >= 0 && customer_price > 0 ? ((profit / customer_price) * 100).toFixed(2) : -100

	/**
	 * Find the total group size for the booking
	 */
	const groupSize = (details.golfers || 0) + (details.non_golfers || 0)

	/**
	 * Commission calculations
	 */
	const hasCommsLogs = commissionData?.hasLogs || false
	const discrepancyAmount = hasCommsLogs ? (agents_margin - (commissionData?.totalPaid || 0)).toFixed(2) : agents_margin?.toLocaleString()

	return (
		<tr>
			<td>
				{details.missing_values && <div className="no-values-tag"></div>}
				{bookedDate}
			</td>
			<td>{details?.reference}</td>
			<td>{typeof details?.direct_booking_details?.id !== "undefined" ? "GHD-DIRECT" : details?.enquiry?.site}</td>
			<td>
				{agent?.first_name} {agent?.last_name}
			</td>
			<td>
				{client?.first_name && `${client.first_name} ${client.last_name}`}
				{!client?.first_name && <small className="no-value">No name set</small>}
			</td>
			{show_email && <td>{client?.email}</td>}
			<td>{checkInDate}</td>
			<td>
				{returnDate}
				{!returnDate && <small className="no-value">Return not calculated</small>}
			</td>
			<td>{groupSize}</td>
			<td>{details.booked_location ? details.booked_location : details.enquiry?.location}</td>
			<td>£{details?.margins?.flights_cost?.toLocaleString() || 0}</td>
			<td>£{details?.margins?.customer_price?.toLocaleString() || 0}</td>
			<td>£{details?.paid_by_client?.toLocaleString() || 0}</td>
			<td>£{details?.margins?.supplier_invoices?.toLocaleString() || 0}</td>
			<td>
				£{details?.margins?.profit?.toLocaleString()} ({bookingProfitPercent}%)
			</td>
			<td>£{agents_margin?.toLocaleString()}</td>
			<td>£{discrepancyAmount}</td>
			<td>
				{details.confirmed && (
					<Badge
						label="Yes"
						type="POSITIVE"
					/>
				)}

				{!details.confirmed && (
					<Badge
						label="No"
						type="NEGATIVE"
					/>
				)}
			</td>
			<td>
				{details.resorts_paid && (
					<Badge
						label="Yes"
						type="POSITIVE"
					/>
				)}

				{!details.resorts_paid && (
					<Badge
						label="No"
						type="NEGATIVE"
					/>
				)}
			</td>
			<td className="is-button">
				<NavLink to={`booking/${id}`}>View booking</NavLink>
				<a
					target="_blank"
					rel="noreferrer"
					href={`booking/${id}`}>
					View in new tab
				</a>
			</td>
		</tr>
	)
}

export default Booking
